import React from "react";
import buildCon from "../images/building construction.png";
import comBuild from "../images/commercial building.png";
import dataCen from "../images/data center.png";
import oilGas from "../images/oil n gas.png";
import solar from "../images/solar panels.png";
import powerPlant from "../images/powerplant.png";

const Applications = () => (
    <div className='white-cards-wrapper'>
        <h3 style={{ color: '#e47931' }}>Our Applications</h3>
        <h1>Build, Evolve and Sustain</h1>
        <div className='white-card-container'>
            <div className='white-card'>
                <img src={comBuild} alt="Commercial building construction" />
                <h3>Commercial Building Construction</h3>
                <p>In the realm of multi-unit residential and commercial buildings, steel cable trays play a pivotal role in ensuring organized and efficient cable routing. These trays are particularly valuable in modern or large-scale construction projects, where they provide a robust and reliable solution for managing electrical and communication cables.</p>
            </div>
            <div className='white-card'>
                <img src={buildCon} alt="Industrial construction" />
                <h3>Industrial Construction</h3>
                <p>Industrial environments demand robust and efficient cable management systems. Steel cable trays are widely utilized in these settings to support and safeguard electrical cables, ensuring safe, organized, and efficient operations in factories, plants, and other industrial facilities.</p>
            </div>
            <div className='white-card'>
                <img src={powerPlant} alt="Power plant" />
                <h3>Power Generation</h3>
                <p>Power plants require extensive electrical cabling for power distribution and control systems. Steel cable trays are an integral part of these facilities, providing a durable and organized solution for managing the complex network of cables essential for seamless power generation and distribution.</p>
            </div>

            <div className='white-card'>
                <img src={dataCen} alt="Data center" />
                <h3>Data Centers</h3>
                <p>Data centers rely on meticulous cable management to maintain optimal network performance and minimize downtime. Steel cable trays offer a flexible and accessible solution for organizing and routing data cables, ensuring efficient operations and simplifying maintenance and future expansions.</p>
            </div>
            <div className='white-card'>
                <img src={oilGas} alt="Oil and gas industry" />
                <h3>Oil and Gas</h3>
                <p>In the challenging environments of oil refineries, offshore platforms, and related facilities, steel cable trays provide a reliable means of organizing and protecting cables. These trays are designed to withstand harsh conditions, ensuring safety and efficiency in critical operations.</p>
            </div>
            <div className='white-card'>
                <img src={solar} alt="Solar panels" />
                <h3>Solar Plants</h3>
                <p>Solar energy installations, such as solar farms and rooftop solar panel arrays, benefit greatly from the use of steel cable trays. These trays facilitate the organized routing and protection of cables, ensuring the efficiency and longevity of solar power systems.</p>
            </div>
        </div>
    </div>
);
export default Applications;